import { ReactNode } from 'react'
import Button from '../Button/Button'
import Header from '../Header/Header'
import { ImageStandAlone as Image } from '../Image/Image'
import Video from '../Video/Video'

interface TwoThreeFourButton {
  text: string
  link: {
    href: string
  }
}

interface TwoThreeFourImage {
  src: string
  alt?: string
}

export interface TwoThreeFourItemProps {
  /**
   * Card image
   */
  image?: TwoThreeFourImage
  /**
   * Card video (YouTube URL)
   */
  video?: string
  /**
   * Card header/title
   */
  header: string
  /**
   * Card body
   */
  body: ReactNode
  /**
   * Card button
   */
  button: TwoThreeFourButton
}

export default function TwoThreeFourItem({
  image,
  video,
  header,
  body,
  button,
}: TwoThreeFourItemProps) {
  return (
    <article className="flex flex-col h-[360px] md:h-[340px] lg:h-[320px] items-start">
      <div className="w-full h-[160px] rounded-lg overflow-hidden mb-3">
        {video ? (
          <Video videoUrl={video} overrideClassName={true} />
        ) : (
          image?.src && (
            <Image
              className="w-full h-full object-cover object-center"
              src={image.src}
              alt={image.alt ? image.alt : ''}
            />
          )
        )}
      </div>
      <Header
        as="h3"
        className="type-headline-3 line-clamp-1 lg:type-body-1 lg:line-clamp-1 mb-3"
      >
        {header}
      </Header>
      <div className="line-clamp-3 lg:line-clamp-3 flex-1 mb-4 text-sm leading-relaxed">
        {body}
      </div>
      <Button
        className="[&]:text-sm min-w-[110px] [&]:min-h-9 mt-auto"
        link={button.link}
        variant="secondary"
      >
        {button.text}
      </Button>
    </article>
  )
}
